// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-q_gc","advertDetailServiceList__header":"c-q_ge","advertDetailServiceList__list":"c-q_gf"};